module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "calling-the-god-and-goddess"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "section-head"
  }, [_c('img', {
    attrs: {
      "alt": "ctgag.eps",
      "src": "images/ctgag_fmt.jpeg"
    }
  }), _c('a', {
    attrs: {
      "id": "calling-the-god-and-goddess-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "calling-the-god-and-goddess-anchor"
    }
  }), _c('p', {
    staticClass: "dtxnoi"
  }, [_c('a', {
    attrs: {
      "id": "calling-the-god-and-goddess-anchor"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("In some ways this is the heart of all Wiccan ritual, and indeed is the only necessary part. Wiccan rites are attunements with the powers that are the Goddess and God; all else is pageantry."), _c('span', {
    staticClass: "fnref"
  })])]), _c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-201-1",
      "id": "footnote-201-1-backlink"
    }
  }, [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("The word “invocation” shouldn’t be taken too literally. This usually refers to a spoken prayer or verse, but may also consist of music, dance, gestures, and song.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("There are several invocations to the Goddess and God here. Feel free to use them when designing your own rituals, but remember that impromptu invocations are often more effective than the most ancient prayers.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("If you do write up your own invocations, you may wish to incorporate a rhyme. Centuries of magical tradition attest to the value of rhyme. It certainly makes invocations that much easier to memorize.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Rhyme also contacts the unconscious or psychic mind. It drowses our societally, materially, and intellectually based minds and lets us slip into ritual consciousness.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("When actually invoking, don’t curse if you forget a word, mispronounce something, or entirely lose your train of thought. This is quite natural and is usually a manifestation of fatigue, stress, or a desire to be word perfect in the Circle.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Invocation requires a willingness to open yourself to the Goddess and God. It needn’t be a pristine performance. As most rituals begin with invocation, this is, in a sense, the moment of truth. If the invocation isn’t sincere, it won’t contact the Goddess and God within, and the ritual that follows will be nothing more than form.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Practice invoking the Goddess and God, not only in ritual but daily, throughout your life. Remember: Wiccan practice isn’t limited to Full Moons or Sabbats—it is a round-the-clock way of life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("In a more metaphysical sense, invocation is a dual-level act. It not only invokes the Goddess and God, it also awakens us (shifts our awareness) to that part of us that is divine—our inviolable, intransmutable essence: our link with the Old Ones.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("In other words, when you invoke do so not only to higher forces but also to the deities that dwell within, to that spark of divine energy that exists inside all living creatures.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Excerpted from ")]), _c('span', {
    staticClass: "normal"
  }, [_vm._v("Wicca: A Guide for the Solitary Practitioner")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(" by Scott Cunningham")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Calling the Gods")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Arms outstretched:")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Gracious Goddess, you who are the Queen of the Gods, the Lamp of Night; the Creator of all that is wild and free; the mother of woman and man; lover of the Horned God and protectress of all the Wicca; descend, we pray you, with your lunar shaft of power upon our Circle here.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Horned One, you who are King of the Gods; Lord of the Sun; Master of all that is wild and free; father of woman and man; lover of the Moon Goddess and protector of all the Wicca; descend, we pray you, with your solar ray of power, upon our Circle here.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Song of the Goddess")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am the Great Mother Binah, worshipped by men since creation and existing before their consciousness. I am the primal female force: boundless and eternal.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am the Goddess of the Moon, chaste Diana, the Lady of all magic. The winds and moving leaves sing my name. I wear the crescent Moon upon my brow and my feet rest among the starry heavens. I am mysteries yet unsolved; a path newly set upon; I am a field yet untouched by the plow. Rejoice in me and be free.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am the blessed mother Demeter, the gracious lady of the harvest. I am clothed with the deep, cool wonder of the earth and the gold of the fields, heavy with grain. By me the tides of the Earth are ruled, all things come to fruit according to my season. I am refuge and healing. I am the mother, giving life to the universe. I have been with you from the beginning and I am with you for eternity.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Worship me as Hecate, the unbroken cycle of death and rebirth. I am the wheel, the shadow of the Moon. I rule the tides of men and give release and renewal to weary souls. Though the darkness of death is my domain, the joy of birth is my gift. I know all things and have attained all wisdom.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am the Goddess of the Moon, the Earth, the Seas. My names and strengths are many. All magic and power is mine, all peace and wisdom comes through me. I call unto thy soul; arise and come. I am that which is attained at the end of all desire.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am Diana!")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Call of the Great God")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am Kernunnos, the radiant King of the Heavens, flooding the Earth with warmth and encouraging the hidden seed of creation to burst forth into manifestation. I lift up my shining spear to light the lives of mankind and daily pour forth my gold upon the earth, putting to flight the powers of darkness and illuminating the minds of humanity.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I, too, am Herne, the Hunter, master of the beasts wild and free. I run with the swift stag’s pace and soar as a sacred falcon against the shimmering sky. The ancient woods and wild places emanate my powers and the birds of the air bespeak my hallowedness.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am also Keeper of the Key of Death and Rebirth; I guide the souls through the Gates of Death and beyond, to the lands of eternal Summer. For without death there cannot be birth, and without birth there cannot be life. Though my gift is death, my promise is life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am the Thousand-Named Sun of creation, the spirit of the stag in the wild, and the Lord of the Gates of Death. See in me the yearly cycle of festivals—my birth, death, and rebirth—and know that such is the destiny of all creation.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I am the spark of life, the Secret Seed, the giver of Peace and Rest, and I send my rays of blessings to warm the hearts and strengthen the minds of mankind.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Invocation of the Elements")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Air, Fire, Water, Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Elements of Astral Birth;")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I charge you now; Attend to me!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("In the Circle, rightly cast,")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Safe from psychic curse and blast; ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I charge you now; Attend to me!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("From cave and desert, sea and hill ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("By wand, blade, cup, and pentacle ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I charge you now; Attend to me! ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("This is my will, so mote it be!")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Dismissal of the Elements")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Earth, Water, Fire, and Air ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Elements both strong and fair, ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Return to your abodes now; flee! ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("This is my will, so mote it be!")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#x-contents-anchor"
    }
  }, [_vm._v("[contents]")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('div', {
    staticClass: "footnote1"
  }, [_c('p', {
    staticClass: "fn"
  }, [_vm._v("["), _c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-201-1-backlink",
      "id": "footnote-201-1"
    }
  }, [_vm._v("1")]), _vm._v("]"), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(". Though it should, of course, promote ritual consciousness. Outdoor rituals rarely need as much invocation because the Wiccans are already surrounded by natural manifestations of the deities.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d22e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calling_the_God_and_Goddess.vue
// module id = 81
// module chunks = 0